import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=20fdb52e&scoped=true&"
import script from "./Timeline.vue?vue&type=script&lang=js&"
export * from "./Timeline.vue?vue&type=script&lang=js&"
import style0 from "./Timeline.scss?vue&type=style&index=0&id=20fdb52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fdb52e",
  null
  
)

export default component.exports